import { createAction, handleActions } from "redux-actions";
import { UPDATE_TRACK_NAME, CLEAR_TRACK_NAME } from "../types";
import scraperConfig from "../scraperConfig";

const defaultState = Object.fromEntries(
    Object.entries(scraperConfig).map(([key]) => [key, { value: "" }])
);

export const updateTrackName = createAction(UPDATE_TRACK_NAME, (trackName, id) => ({
    trackName,
    id
}));

export const clearTrackName = createAction(CLEAR_TRACK_NAME, (id) => ({ id }));

const trackName = handleActions(
    {
        [updateTrackName]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { value: action.payload.trackName }
            };
        },
        [clearTrackName]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { value: "" }
            };
        }
    },
    defaultState
);

export default trackName;
